 
import { request } from "@/utils/api/legacyRequest";

// /* ***********
// BROWSER A USER
// *********** */

export const SET_BROWSE_PROFILE_DATA = "browse/SET_BROWSE_PROFILE_DATA";
export const RESET_BROWSE_PROFILE_DATA = "browse/RESET_BROWSE_PROFILE_DATA";
export const SET_BROWSE_PROFILE_LOADED = "browse/SET_BROWSE_PROFILE_LOADED";

/**
 * A profile that is not there is an expected answer, not a failure: an erased
 * account has its profile row deleted, so `/profile/:id` for one 404s. Marking
 * the request loaded without any profile data is what makes the page render its
 * 404 view — see `doesUserExist` in `src/Pages/Profile/index.tsx`.
 */
const profileNotFound = (dispatch) =>
  dispatch({ type: SET_BROWSE_PROFILE_LOADED });

const receiveProfile = (dispatch) => (response) => {
  if (!response?.data) {
    profileNotFound(dispatch);
    return;
  }

  dispatch({ type: SET_BROWSE_PROFILE_DATA, data: response.data });
  dispatch({ type: SET_BROWSE_PROFILE_LOADED });
};

// `legacyRequest` rejects with the Response itself for a non-2xx status.
const handleProfileError = (dispatch) => (error) => {
  if (error?.status !== 404) {
    console.error(error);
  }

  profileNotFound(dispatch);
};

export function fetchUserProfile(userId) {
  return (dispatch, getState) => {
    const { user } = getState();

    const jwt = user.get("jwt");

    const apiEndpoint =
      window?.env?.VITE_API_ENDPOINT || import.meta.env.VITE_API_ENDPOINT;

    const url = jwt
      ? `${apiEndpoint}/api/v2/rebel/user-profile/rebel-profiles/${userId}`
      : `${apiEndpoint}/api/v2/public/user-profile/rebel-profiles/${userId}`;

    return request(url, jwt ?? null)
      .then(receiveProfile(dispatch))
      .catch(handleProfileError(dispatch));
  };
}

/* *************
BROWSER AN EVENT
************* */
export const SET_BROWSE_EVENT_DATA = "browse/SET_BROWSE_EVENT_DATA";
export const SET_BROWSE_EVENT_NOT_FOUND = "browse/SET_BROWSE_EVENT_NOT_FOUND";
